import { Injectable } from '@angular/core';
import { BsDatepickerConfig } from './pmd-datepicker.config';

@Injectable()
export class PmdDatepickerInlineConfig extends BsDatepickerConfig {}
